<template>
  <div class="d-flex justify-content-center align-items-center" style="height: 80vh;">
    <div class="text-center">
      <h1 class="text-danger fw-bold" style="font-size: 2.2rem;">
        Você não tem permissão para acessar este item
      </h1>
      <p class="mt-3 text-secondary" style="font-size: 1.2rem;">
        Solicite permissão com o suporte.
      </p>
    </div>
  </div>
</template>


<script>

import * as bootstrap from 'bootstrap';


import { defineComponent } from "vue";
import fintailapi from "../api";

export default defineComponent({
  name: "permissao",

  data() {
    return {
      cfg: [],
      selectedCfg: {
        id: null,
        key: "",
        value: "",
      },
    };
  },

  mounted() {
  
  },

  methods: {

  },
});
</script>
